import type { ReassuranceTheme } from '@backmarket/http-api/src/api-specs-content/models/reinsurance'
import { tw } from '@backmarket/utils/string/tw'
import type { Maybe } from '@backmarket/utils/types/Maybe'

export const getGridColsClass = (itemsCount: number) => {
  switch (itemsCount) {
    case 3:
      return 'md:grid-cols-3'

    case 4:
      return 'md:grid-cols-4'

    case 5:
      return 'md:grid-cols-3'

    case 6:
      return 'md:grid-cols-3'

    case 7:
      return 'md:grid-cols-4'

    case 8:
      return 'md:grid-cols-4'

    default:
      return 'md:grid-cols-4'
  }
}

export const getBackgroundClasses = ({
  theme,
  hasBackground,
}: {
  theme?: Maybe<ReassuranceTheme>
  hasBackground?: Maybe<boolean>
}): { iconContainerClass: string; containerClass: string } => {
  switch (theme) {
    case 'white':
      return {
        containerClass: hasBackground ? 'bg-surface-default-low' : '',
        iconContainerClass: hasBackground
          ? 'bg-surface-default-hi'
          : 'bg-surface-default-low',
      }

    case 'gray':
      return {
        containerClass: hasBackground ? 'bg-surface-default-hi' : '',
        iconContainerClass: hasBackground
          ? 'bg-surface-default-low'
          : 'bg-surface-default-hi',
      }

    case 'yellow':
      return {
        containerClass: hasBackground ? 'bg-static-brand-hi' : '',
        iconContainerClass: hasBackground
          ? 'bg-surface-default-low'
          : 'bg-static-brand-hi',
      }

    case 'purple':
      return {
        containerClass: hasBackground ? 'bg-static-brand-low' : '',
        iconContainerClass: hasBackground
          ? 'bg-surface-default-low'
          : 'bg-static-brand-low',
      }
    default:
      return { containerClass: '', iconContainerClass: '' }
  }
}

const getIconClass = ({ theme }: { theme?: Maybe<ReassuranceTheme> }) => {
  return theme === 'purple'
    ? tw`text-static-brand-hi`
    : tw`text-static-default-hi`
}

export const getTextClampingClasses = (props: {
  description?: Maybe<string>
  mobileScreenCols?: Maybe<number>
}) => {
  const hideDescription = props.mobileScreenCols === 2

  const description = hideDescription ? '' : props.description

  return {
    titleClass: [
      tw`overflow-wrap-anywhere`,
      description ? tw`line-clamp-1` : tw`line-clamp-2`,
    ],
    descriptionClass: hideDescription
      ? tw`hidden`
      : tw`line-clamp-1 overflow-wrap-anywhere`,
  }
}

export function getClasses({
  theme,
  hasBackground,
  itemsCount,
  mobileScreenCols,
}: {
  theme?: Maybe<ReassuranceTheme>
  hasBackground?: Maybe<boolean>
  itemsCount: number
  mobileScreenCols?: Maybe<number>
}): {
  containerClass: (string | Record<string, boolean>)[]
  iconContainerClass: string
  iconClass: string
} {
  const backgroundClasses = getBackgroundClasses({ theme, hasBackground })
  const gridColsClass = getGridColsClass(itemsCount)
  const iconClass = getIconClass({ theme })

  return {
    containerClass: [
      backgroundClasses.containerClass,
      gridColsClass,
      {
        'grid-cols-1': mobileScreenCols === 1,
        'grid-cols-2': mobileScreenCols === 2,
      },
    ],
    iconContainerClass: backgroundClasses.iconContainerClass,
    iconClass,
  }
}
